// modules/Home.js
import React ,{ Component } from 'react';
import NavLink from './NavLink'
import Web3 from 'web3'
import ecommerce from '../img/ecommerce.jpg'
class Home extends Component {
	constructor(props){
		super(props)
		window.addEventListener('load', function() {
		var ETH_CLIENT
		
		if (typeof web3 !== 'undefined')
			{
				// eslint-disable-next-line no-undef
				ETH_CLIENT = new Web3(web3.currentProvider)
				
			}
		else
			{
				ETH_CLIENT = new Web3(new Web3.providers.HttpProvider("http://localhost:8545"));
				
			}
		
      const myetherescrowABI = [{"constant":true,"inputs":[{"name":"inputAddress","type":"address"},{"name":"startID","type":"uint256"},{"name":"numToLoad","type":"uint256"}],"name":"SellerHistory","outputs":[{"name":"","type":"address[]"},{"name":"","type":"address[]"},{"name":"","type":"uint256[]"},{"name":"","type":"bytes32[]"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"fee","type":"uint256"}],"name":"setEscrowFee","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"name":"","type":"address"},{"name":"","type":"uint256"}],"name":"sellerDatabase","outputs":[{"name":"buyer","type":"address"},{"name":"buyer_nounce","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"name":"buyerAddress","type":"address"},{"name":"startID","type":"uint256"},{"name":"numToLoad","type":"uint256"}],"name":"buyerHistory","outputs":[{"name":"","type":"address[]"},{"name":"","type":"address[]"},{"name":"","type":"uint256[]"},{"name":"","type":"bytes32[]"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"name":"","type":"address"}],"name":"escrowFee","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"name":"fromAddress","type":"address"}],"name":"CheckBalance","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"switcher","type":"uint256"},{"name":"ID","type":"uint256"}],"name":"EscrowEscalation","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[],"name":"WithdrawFunds","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"name":"inputAddress","type":"address"},{"name":"switcher","type":"uint256"},{"name":"ID","type":"uint256"}],"name":"getSpecificTransaction","outputs":[{"name":"","type":"address"},{"name":"","type":"address"},{"name":"","type":"address"},{"name":"","type":"uint256"},{"name":"","type":"bytes32"},{"name":"","type":"uint256"},{"name":"","type":"bytes32"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"name":"escrowAddress","type":"address"}],"name":"getEscrowFee","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"name":"buyerAddress","type":"address"},{"name":"nounce","type":"uint256"}],"name":"checkStatus","outputs":[{"name":"","type":"bytes32"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"owner","outputs":[{"name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"ID","type":"uint256"}],"name":"sellerRefund","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"ID","type":"uint256"},{"name":"Decision","type":"uint256"}],"name":"escrowDecision","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"name":"","type":"address"},{"name":"","type":"uint256"}],"name":"buyerDatabase","outputs":[{"name":"buyer","type":"address"},{"name":"seller","type":"address"},{"name":"escrow_agent","type":"address"},{"name":"escrow_fee","type":"uint256"},{"name":"amount","type":"uint256"},{"name":"escrow_intervention","type":"bool"},{"name":"release_approval","type":"bool"},{"name":"refund_approval","type":"bool"},{"name":"notes","type":"bytes32"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"name":"inputAddress","type":"address"},{"name":"switcher","type":"uint256"}],"name":"getNumTransactions","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"name":"inputAddress","type":"address"},{"name":"startID","type":"uint256"},{"name":"numToLoad","type":"uint256"}],"name":"escrowHistory","outputs":[{"name":"","type":"address[]"},{"name":"","type":"address[]"},{"name":"","type":"uint256[]"},{"name":"","type":"bytes32[]"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"ID","type":"uint256"}],"name":"buyerFundRelease","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"sellerAddress","type":"address"},{"name":"escrowAddress","type":"address"},{"name":"notes","type":"bytes32"}],"name":"newEscrow","outputs":[{"name":"","type":"bool"}],"payable":true,"stateMutability":"payable","type":"function"},{"constant":true,"inputs":[{"name":"","type":"address"},{"name":"","type":"uint256"}],"name":"escrowDatabase","outputs":[{"name":"buyer","type":"address"},{"name":"buyer_nounce","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"name":"","type":"address"}],"name":"Funds","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"inputs":[],"payable":false,"stateMutability":"nonpayable","type":"constructor"},{"payable":true,"stateMutability":"payable","type":"fallback"}]
      
      const myetherescrowAddress = '0x1c02ce498dc6d0d6ef05a253e021258b07eeba91'
      
      
      const EscrowMyEtherEntityDB_ABI = [{"constant":false,"inputs":[{"name":"_name","type":"string"},{"name":"_info","type":"string"}],"name":"registerSeller","outputs":[],"payable":false,"type":"function"},{"constant":true,"inputs":[{"name":"escrowAddress","type":"address"}],"name":"getEscrowFullInfo","outputs":[{"name":"","type":"string"},{"name":"","type":"string"}],"payable":false,"type":"function"},{"constant":true,"inputs":[{"name":"","type":"address"}],"name":"buyerList","outputs":[{"name":"name","type":"string"},{"name":"info","type":"string"}],"payable":false,"type":"function"},{"constant":true,"inputs":[{"name":"sellerAddress","type":"address"}],"name":"getSellerFullInfo","outputs":[{"name":"","type":"string"},{"name":"","type":"string"}],"payable":false,"type":"function"},{"constant":true,"inputs":[],"name":"owner","outputs":[{"name":"","type":"address"}],"payable":false,"type":"function"},{"constant":true,"inputs":[{"name":"buyerAddress","type":"address"}],"name":"getBuyerFullInfo","outputs":[{"name":"","type":"string"},{"name":"","type":"string"}],"payable":false,"type":"function"},{"constant":true,"inputs":[{"name":"","type":"address"}],"name":"sellerList","outputs":[{"name":"name","type":"string"},{"name":"info","type":"string"}],"payable":false,"type":"function"},{"constant":false,"inputs":[{"name":"_name","type":"string"},{"name":"_info","type":"string"}],"name":"registerBuyer","outputs":[],"payable":false,"type":"function"},{"constant":true,"inputs":[{"name":"","type":"address"}],"name":"escrowList","outputs":[{"name":"name","type":"string"},{"name":"info","type":"string"}],"payable":false,"type":"function"},{"constant":false,"inputs":[{"name":"_name","type":"string"},{"name":"_info","type":"string"}],"name":"registerEscrow","outputs":[],"payable":false,"type":"function"},{"inputs":[],"payable":false,"type":"constructor"},{"payable":true,"type":"fallback"}]
      const EscrowMyEtherEntityDB_address = '0xcf356ab67132c1359ebdd0ccc928fdb020eaa929'

		this.state = {

		
		
		//window.web3 = new Web3(web3.currentProvider)
		
		//var ETH_CLIENT = new Web3(new Web3.providers.HttpProvider("http://localhost:8545"))
		
		mee: ETH_CLIENT.eth.contract(myetherescrowABI).at(myetherescrowAddress),

		
		entitydb: ETH_CLIENT.eth.contract(EscrowMyEtherEntityDB_ABI).at(EscrowMyEtherEntityDB_address),

		accounts: ETH_CLIENT.eth.accounts,
		
		}

		
	})
  

  }
  

  
  render() {
    var error = ""
    var table = ""
    if (typeof web3 == 'undefined')
      {
        error = <p className="small red center">Ethereum node not detected, dashboard disabled. Please double check if node is active.</p>
        table = (
          <table className="home">
          <tr>
            <td><NavLink to="/"><button className="HomeButton">Buyer Dashboard</button></NavLink></td>
            <td></td>
            <td><NavLink to="/"><button className="HomeButton">Seller Dashboard</button></NavLink></td>
            <td></td>
            <td><NavLink to="/"><button className="HomeButton">Escrow Dashboard</button></NavLink></td>
            </tr>
    
        </table>
        )
      }
    else
      {
        table = (<table className="home">
        <tr>
          <td><NavLink to="/buyer"><button className="HomeButton">Buyer Dashboard</button></NavLink></td>
          <td></td>
          <td><NavLink to="/seller"><button className="HomeButton">Seller Dashboard</button></NavLink></td>
          <td></td>
          <td><NavLink to="/escrow"><button className="HomeButton">Escrow Dashboard</button></NavLink></td>
          </tr>
  
      </table>)
      error = ""
      }

    return (
    
      
     <div>
       <div className="header_section">
         <div id="headertext">
           <h1 className="header">EscrowMyEther</h1>
           <h2>Send and Receive Ether with Escrow Protection.</h2>
           </div>
         </div>
         <div className="bg-lb height100">
          <div className="narrow-body-container">

          
      <br/><br/>
    <h2 className="center">Decentralized Escrow System</h2><br/>
    <p className="center">Open Source Ethereum Smart Contract that allows 2 transacting parties, a Buyer and Seller, to transact with their choice of Escrow Agent.
    
    </p>
    <br/><br/>
    <h2 className="center">How It Works</h2><br/>
    <p>When Buyer initializes an escrow transaction, his Ether is locked in the smart contract. Once Buyer confirms the Seller’s obligations are fulfilled, he can release funds to Seller.
       An Escrow Agent, chosen by the Buyer and Seller oversees the transaction. If a dispute occurs, the Escrow Agent can intervene and refund the Buyer, 
       or release funds to the Seller. 
    
    </p> 
    <img src="https://user-images.githubusercontent.com/24837709/30773541-3d81c506-a0a5-11e7-9e4c-28e322cdc5b8.png"/>

    
    </div>
    <div className="white-bg2">
    <div className="narrow-body-container"><br/><br/>
    <h2 className="center">Transparent Fees</h2><br/>
    <p className="center">EscrowMyEther is free for Buyers and Escrow Agents to use. Sellers are charged a percentage Escrow Fee and a 0.25% developer fee.</p>
    <img src="https://user-images.githubusercontent.com/24837709/30874805-fe07e4c4-a323-11e7-8677-693868458ac1.png"/>
    <br/>
    <p className="center">- Choose a fair and unbiased entity to escrow your transactions, such as a forum moderator<br/>
  - Escrow Agent typically charges 1-2% fee for normal E-commerce transactions<br/>
  - For your safety, never ship orders escrowed by unknown Escrow Agents</p>
    </div>
    </div>

    <div className="bg-lb">
    <div className="narrow-body-container"><br/><br/>
    <h2 className="center">Benefits</h2><br/>
    <p className="center">Fair dispute resolution and lower fees reduces the cost of selling online.
    </p>
    <img src="https://user-images.githubusercontent.com/24837709/30779511-99d78f40-a125-11e7-9f20-cb01f826ecea.png"/>
    <br/>
    </div>
    </div>

    <div className="white-bg2">
    <div className="narrow-body-container"><br/><br/>
    <h2 className="center">Withdraw Funds Anytime</h2><br/>
    <p className="center">One advantage of decentralization: No governing entity controls your funds, no one can prevent you from withdrawing your funds.</p>
    <img src="https://user-images.githubusercontent.com/24837709/30780468-ded9a58e-a13d-11e7-8ecb-ac79fe93bc3f.png"/>
    
    <p className="center">Withdraw funds as each transaction is complete, or accumulate multiple transactions and withdraw them in one go.</p>
    <br/>
    </div>
    </div>
    <div className="bg-lb">
      <div className="narrow-body-container">
    <br/><br/>
    <h2 className="center">Get Started</h2><br/>
    <p className="center">To use EscrowMyEther, connection to an Ethereum node is required. We recommend the Metamask chrome extension, as they provide a remote node and is easiest to setup.
       For power users who wish to run their local node, use the Parity chrome extension.  
       For now, the Dapp is only supported on Google Chrome, on screens above 1366x768 resolution.</p><br/>
    <p className="center"><a href="https://chrome.google.com/webstore/detail/metamask/nkbihfbeogaeaoehlefnkodbefgpgknn" target="_blank"><font className="linkfont">Metamask Chrome Extension</font></a><br/>
    <a href="https://chrome.google.com/webstore/detail/parity-ethereum-integrati/himekenlppkgeaoeddcliojfddemadig" target="_blank"><font className="linkfont">Parity Chrome Extension</font></a></p>
    <br/>
    <p className="center">When Metamask or Parity is setup, you should see a "connection established" message on top of this page.</p><br/>
    <img src="https://user-images.githubusercontent.com/24837709/30780879-e03f5752-a147-11e7-9a81-ad5ddd3a227f.png"/><br/><br/><br/>

    <h2 className="center">Enter Dapp Dashboard</h2><br/>
    
      {table}
    {error}<br/>
    <div id="readme"></div>
    <p className="center">Video guide to using dashboard<br/>
    <iframe width="560" height="315" src="https://www.youtube.com/embed/T2_XzSlddWI?rel=0" frameborder="0" allowfullscreen></iframe><br/><br/>
    </p>
    
    </div>
    </div>
    <div className="white-bg2">
      <div className="narrow-body-container">
      <br/><br/>
    
    
      <h2 className="center">For Developers</h2><br/>
      <p className="center">Links to the open source contract code, bug bounty program and github.</p><br/>
      <table className="home">
        <tr>
          <td><a href="https://etherscan.io/address/0x1c02ce498dc6d0d6ef05a253e021258b07eeba91" target="_blank"><button className="HomeButton">Contract Source Code</button></a></td>
          <td></td>
          <td><a href="https://github.com/KayinCheung/KayinCheung.github.io" target="_blank"><button className="HomeButton">Github Repository</button></a></td>
          <td></td>
          <td><a href="https://www.reddit.com/r/ethdev/comments/6zwb1x/escrowmyether_1_eth_bug_bounty/" target="_blank"><button className="HomeButton">Bug Bounty</button></a></td>
          </tr>
          
      </table>
   
  
    </div>
    </div>

    <div className="bg-lb">
      <div className="narrow-body-container"><br/><br/>

      <h2 className="center">Contact</h2><br/>
      <p className="center">Escrowmyether[at]gmail[dot]com</p><br/>
      </div>
      </div>    
      </div>
      </div>
      
    )
  }
}


export default Home;


// WEBPACK FOOTER //
// ./src/Home.js